import { render, staticRenderFns } from "./workload-buyouts.vue?vue&type=template&id=68dfc794&"
import script from "./workload-buyouts.vue?vue&type=script&lang=js&"
export * from "./workload-buyouts.vue?vue&type=script&lang=js&"
import style0 from "./workload-buyouts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports